import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import { actionCreators } from "../redux/membershipUnitsSagas";

export const PreviousToggle = () => {
  const dispatch = useDispatch();
  const previousToggleValue = useSelector((state) => state.membershipUnits.previousToggleValue);

  return (
    <div className="toggle">
      <p>Show Previous Data</p>
      <ToggleableButton
        isRadio
        isActive={previousToggleValue}
        label="membership-units-previous-toggle"
        title="show-previous-data"
        onClick={(val) => {
          dispatch(actionCreators.updatePreviousDataToggle(val));
        }}
      />
    </div>
  );
};
